import { TFunction } from 'next-i18next'
import { Subscription } from 'src/core/models'

export const subscriptionData = (t: TFunction): Subscription[] => [

  {
    mainlabel: t('Subscription.Support'),
    basicPlanLabel: t('Subscription.Developers'),
    proPlanLabels: [
      t('Subscription.Developers'),
      t('Subscription.Email'),
      t('Subscription.Assisted'),
      t('Subscription.10Hours'),
    ],
    premiumPlanLabels: [
      t('Subscription.Developers'),
      t('Subscription.Email'),
      t('Subscription.Product'),
      t('Subscription.30Hours'),
    ]
  },

  {
    mainlabel: t('Subscription.CalculatorAPI'),
    basicPlanLabel: t('Subscription.NotIncluded'),
    proPlanLabels: [ t('Subscription.200Requests')],
    premiumPlanLabels: [t('Subscription.Unlimited')]
  },

  {
    mainlabel: t('Subscription.OffsetAPI'),
    basicPlanLabel: t('Subscription.UnlimitedCalls'),
    proPlanLabels: [t('Subscription.UnlimitedCalls')],
    premiumPlanLabels: [t('Subscription.UnlimitedCalls')]
  },

  {
    mainlabel: t('Subscription.Async'),
    basicPlanLabel: t('Subscription.ManualUploading'),
    proPlanLabels: [t('Subscription.AutomaticProcessing')],
    premiumPlanLabels: [t('Subscription.AutomaticProcessing')]
  },

  {
    mainlabel: t('Subscription.Whitelabel'),
    basicPlanLabel: t('Subscription.NotIncluded'),
    proPlanLabels: [t('Subscription.Included')],
    premiumPlanLabels: [t('Subscription.Included')]
  },

  {
    mainlabel: t('Subscription.ExtraSupport'),
    basicPlanLabel: t('Subscription.5Hours'),
    proPlanLabels: [t('Subscription.5Hours')],
    premiumPlanLabels: [t('Subscription.5Hours')]
  },

  {
    mainlabel: t('Subscription.Marketing'),
    basicPlanLabel: t('Subscription.NotIncluded'),
    proPlanLabels: [t('Subscription.NotIncluded')],
    premiumPlanLabels: [t('Subscription.Included')]
  },

  {
    mainlabel: t('Subscription.OtherFeatures'),
    basicPlanLabel: t('Subscription.NotIncluded'),
    proPlanLabels: [t('Subscription.FileMassive')],
    premiumPlanLabels: [t('Subscription.FileMassive')]
  },

  {
    mainlabel: t('Subscription.Look'),
    basicPlanLabel: t('Subscription.500Requests'),
    proPlanLabels: [t('Subscription.500Requests')],
    premiumPlanLabels: [t('Subscription.500Requests')]
  }
]
